import CryptoJS from 'crypto-js';

// start_ai_generated
export const buildSignature = (key: string, ts: number, once: string, body?: string): string => {
  const message = body ? `${ts}+${once}+${body}` : `${ts}+${once}`;
  const hmac = CryptoJS.HmacSHA256(message, key);
  return hmac.toString(CryptoJS.enc.Hex);
};

export const checkResponseSignature = async (key: string, randomField: { ts: number; once: string }, respObj: { data: string; signature: string }): Promise<boolean> => {
  const signature = await buildSignature(key, randomField.ts, randomField.once, respObj.data);
  return signature === respObj.signature;
};

export const AesCBCEncryptV2 = async (sourceData: string, key: string): Promise<string> => {
  const blockSize = 16;
  const keyByte = CryptoJS.enc.Hex.parse(key);

  if (keyByte.words.length * 4 < blockSize) {
    throw new Error('AesCBCEncrypt:keyByte too short');
  }

  const iv = CryptoJS.lib.WordArray.random(blockSize);
  const padded_data = CryptoJS.enc.Utf8.parse(sourceData);
  const cipher = CryptoJS.AES.encrypt(padded_data, keyByte, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const data = iv.concat(cipher.ciphertext);
  const aes_result_base64 = CryptoJS.enc.Base64.stringify(data);

  return aes_result_base64;
};

export const AesCBCDecryptV2 = async (sourceData: string, key: string): Promise<string> => {
  const blockSize = 16;
  const keyByte = CryptoJS.enc.Hex.parse(key);

  if (keyByte.sigBytes < blockSize) {
    throw new Error('AesCBCDecrypt:keyByte too short');
  }

  const byteValue = CryptoJS.enc.Base64.parse(sourceData);
  if (byteValue.sigBytes < blockSize) {
    throw new Error('sourceData too short');
  }

  const iv = byteValue.words.slice(0, blockSize / 4);
  const encryptedBytes = byteValue.words.slice(blockSize / 4);

  const cipher = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.lib.WordArray.create(encryptedBytes),
  });

  const decryptedBytes = CryptoJS.AES.decrypt(cipher, keyByte, {
    iv: CryptoJS.lib.WordArray.create(iv),
    padding: CryptoJS.pad.Pkcs7,
  });

  return decryptedBytes.toString(CryptoJS.enc.Utf8);
};
// end_ai_generated